'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/call-bound/~/function-bind/index.js
// module id = 2070
// module chunks = 67